import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record14Api = {
    //查詢展館
    "getRecord14List": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/getRecord14List`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                recordno: -1,
                addinfo17: '0',  //0展館 1商場 -1島
            }
        }
    },
    //關鍵字分頁查詢展館
    "getRecord14InfoByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/getRecord14InfoByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                // recordno: -1,
                addinfo10: null,  //展會類別 0國際展會 1本地展會
                recordname: null, //keyword
                addinfo17: '0',  //0展館 1商場 -1島
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //分頁查詢展館信息
    "getRecord14InfoPageByCompanycode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/getRecord14InfoPageByCompanycode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo17: '0',
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //統計展會數量
    "countAdditionalrecord14": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/countAdditionalrecord14`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo17: '0'
            }
        }
    },
    //办展
    "insertRecord14": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/insertRecord14`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                recordname: '',
                companycode: null,
                addinfo1: '',
                addinfo2: '',
                addinfo3: '',
                addinfo4: '',
                addinfo5: '',
                addinfo6: '',
                addinfo7: '',
                addinfo8: '',
                addinfo10: '',
                addinfo11: null,
                addinfo12: null,
                addinfo15: null,
                addinfo16: null,
                addinfo17: '0',
            }
        }
    },
    //修改展會
    "updateRecord14": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/updateRecord14`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                recordname: '',
                companycode: null,
                addinfo1: '',
                addinfo2: '',
                addinfo3: '',
                addinfo4: '',
                addinfo5: '',
                addinfo6: '',
                addinfo7: '',
                addinfo8: '',
                addinfo10: '',
                addinfo11: null,
                addinfo12: null,
                addinfo15: null,
                addinfo16: null,
                addinfo17: '0',
                addinfo19: null
            }
        }
    },
    //查詢商場列表
    "getMallInfoList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/getMallInfoList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo17: '1',
                addinfo18: null,  //是否是岛主 -1是
            }
        }
    },
    //查詢島嶼列表
    "getIslandInfoList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record14/getIslandInfoList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                recordno: -1,
                addinfo17: '-1'
            }
        }
    },
}

export default record14Api